import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next';
import { useColorModeValue } from '@chakra-ui/react';
import { setAnalyticsConsent } from '../../utils/analytics.ts';

interface CookieConsentBannerProps {
  onAccept?: () => void;
  onDecline?: () => void;
}

const CookieConsentBanner: React.FC<CookieConsentBannerProps> = ({ 
  onAccept, 
  onDecline 
}) => {
  const { t } = useTranslation();
  const bg = useColorModeValue('#F7FAFC', '#2D3748');
  const textColor = useColorModeValue('#2D3748', '#E2E8F0');
  const buttonBg = useColorModeValue('#805AD5', '#9F7AEA');
  const declineButtonBorder = useColorModeValue('#CBD5E0', '#4A5568');
  const borderColor = useColorModeValue('#E2E8F0', '#4A5568');

  const handleAccept = () => {
    setAnalyticsConsent(true);
    onAccept?.();
  };

  const handleDecline = () => {
    setAnalyticsConsent(false);
    onDecline?.();
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('cookies.accept')}
      declineButtonText={t('cookies.decline')}
      enableDeclineButton
      onAccept={handleAccept}
      onDecline={handleDecline}
      style={{
        background: bg,
        color: textColor,
        fontSize: "14px",
        padding: "16px 20px",
        zIndex: 9999,
        boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
        borderTop: `1px solid ${borderColor}`
      }}
      buttonStyle={{
        background: buttonBg,
        color: "white",
        fontSize: "14px",
        borderRadius: "6px",
        padding: "8px 16px",
        border: "none",
        marginRight: "8px",
        cursor: "pointer",
        fontWeight: "500"
      }}
      declineButtonStyle={{
        background: "transparent",
        color: textColor,
        fontSize: "14px",
        borderRadius: "6px",
        padding: "8px 16px",
        border: "1px solid",
        borderColor: declineButtonBorder,
        cursor: "pointer",
        fontWeight: "500"
      }}
      expires={365}
      cookieName="quizvs_cookie_consent"
      cookieValue="accepted"
      declineCookieValue="declined"
    >
      <div style={{ maxWidth: "800px", margin: "0 auto", fontSize: "14px" }}>
        <strong style={{ marginBottom: "8px", display: "block" }}>
          {t('cookies.title')}
        </strong>
        <div style={{ lineHeight: "1.4" }}>
          {t('cookies.message')}{" "}
          <a 
            href="/privacy" 
            style={{ 
              color: buttonBg, 
              textDecoration: "underline",
              fontWeight: "500"
            }}
          >
            {t('cookies.learnMore')}
          </a>
        </div>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentBanner;
